import React from 'react';
import { useTranslation } from 'react-i18next';
import WidgetMonthPicker from './WidgetMonthPicker';
import styles from './WidgetPeriodSelect.module.scss';

export type PeriodOption = {
	value: string;
	labelKey: string;
};

type Props = {
	value: string;
	options: PeriodOption[];
	customValue?: string;
	onChange: (value: string) => void;
	dateFrom: Date;
	dateTo: Date;
	onDateRangeChange: (from: Date, to: Date) => void;
};

const WidgetPeriodSelect = ({
	value,
	options,
	customValue = 'custom',
	onChange,
	dateFrom,
	dateTo,
	onDateRangeChange,
}: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.optionsRow}>
			<select
				className={styles.periodSelect}
				value={value}
				onChange={e => onChange(e.target.value)}
			>
				{options.map(opt => (
					<option key={opt.value} value={opt.value}>
						{t(opt.labelKey as any) as string}
					</option>
				))}
			</select>
			{value === customValue && (
				<WidgetMonthPicker dateFrom={dateFrom} dateTo={dateTo} onChange={onDateRangeChange} />
			)}
		</div>
	);
};

export default WidgetPeriodSelect;
